export default __webpack_public_path__ + "static/char-v-31-223f60060923a7ea8b3c63ef3a5ff2c4.webp";